import axios from "axios"

const API_BASE_URL = "/"

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    "Accept": "application/json"
  },
});

export const fetchData = async (endpoint, params = {}) => {
	const response = await api.get(`/${endpoint}`, { params })

	return response.data
}

export const patchData = async (endpoint, data) => {
  const response = await api.patch(`/${endpoint}`, data, {
    headers: {
      "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  });
  return response.data;
};

export const postData = async (endpoint, data) => {
  const response = await api.post(`/${endpoint}`, data, {
    headers: {
      "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  });
  return response.data;
};

export const putData = async (endpoint, data) => {
  const response = await api.put(`/${endpoint}`, data, {
    headers: {
      "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
  });
  return response.data;
};

export const deleteData = async (endpoint) => {
  const response = await api.delete(`/${endpoint}`, {
    headers: {
      "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
      "Accept": "application/json",
    },
  });
  return response.data;
};
